require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/script-loader/addScript.js")(require("!!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/raw-loader/index.js!/Users/gedarufi/Documents/Inger/Amorel/back.amorel/node_modules/bootstrap/js/modal.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/bootstrap/js/modal.js
// module id = 741
// module chunks = 15